// CustomTabs.jsx
import React from "react";
import { Tabs, Tab } from "react-bootstrap";

const CustomTabs = ({ tabs, defaultActiveKey }) => {
  return (
    <Tabs
      defaultActiveKey={defaultActiveKey || tabs[0].eventKey}
      className="mb-3"
    >
      {tabs.map(({ title, eventKey, Component, props }) => (
        <Tab eventKey={eventKey} title={title} key={eventKey}>
          <Component {...props} />
        </Tab>
      ))}
    </Tabs>
  );
};

export default CustomTabs;
